module.exports = __webpack_public_path__ + "staticcomp/img/cover.5b52213.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/2/cover.jpg
// module id = VKI3
// module chunks = 39